import React from "react";
import { Navigate, useParams, generatePath, useLocation } from "react-router-dom";

/**
 * Supports redirectTo patterns with :params (same names as the matched route path).
 * Preserves query string (e.g. ?assetId=) when redirecting.
 */
export function ConfiguredRedirect({ to }) {
  const params = useParams();
  const location = useLocation();
  const search = location.search || "";

  if (to.includes(":") && Object.keys(params).length > 0) {
    try {
      const target = generatePath(to, params);
      return <Navigate to={`${target}${search}`} replace />;
    } catch {
      // fall through
    }
  }

  return <Navigate to={`${to}${search}`} replace />;
}
